import React from "react";
import CardSection from "../../../components/ui/CardSection";
import Icon from "../../../components/ui/Icon";
import { ISaleStatus } from "../../../classes/interfaces";
import { getOrderStatusShort } from "../../../helpers/order.helper";
// getDateTime is defined in OrderSummarySection.tsx (the first component that needed
// it) and imported here rather than duplicated. One-directional sibling import:
// OrderSummarySection.tsx does NOT import anything from this file.
import { getDateTime } from "./OrderSummarySection";
import { Step, StepRail, StepCircle, Connector, StepBody, StepLabel, StepDate } from "./StatusTimeline.styles";

interface StatusTimelineProps {
  statuses?: ISaleStatus[];
}

export default function StatusTimeline({ statuses = [] }: StatusTimelineProps) {
  return (
    <CardSection icon="clock" title="Etapas dos status">
      {statuses.map((status, index) => {
        const isCurrent = index === statuses.length - 1;
        const isLast = index === statuses.length - 1;
        return (
          <Step key={index}>
            <StepRail>
              <StepCircle $current={isCurrent}>
                <Icon name="check" size={14} strokeWidth={3} />
              </StepCircle>
              {!isLast && <Connector />}
            </StepRail>
            <StepBody>
              <StepLabel $current={isCurrent}>{getOrderStatusShort(status.status)}</StepLabel>
              <StepDate>{getDateTime(status.createdAt)}</StepDate>
            </StepBody>
          </Step>
        );
      })}
    </CardSection>
  );
}
